import MemLogoUrl from "@/assets/icons/logo/logo-square.svg?url";
import { MEM_SPACE_ACCOUNT_ID } from "@/store/contacts/constants";
import { ContactObservable } from "@/store/contacts/ContactObservable";
import { SyncModelKind } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";

const memSyncUpdateValue = {
  model_id: MEM_SPACE_ACCOUNT_ID,
  model_kind: SyncModelKind.Contact,
  model_version: 0,
  model_data: {
    space_account_id: MEM_SPACE_ACCOUNT_ID,
    profile_email_address: "",
    profile_photo_url: MemLogoUrl,
    profile_display_name: "Mem",
  },
  model_scopes: [],
};

export class MemContactObservable extends ContactObservable {
  constructor({ store }: WithAppStore) {
    super({ id: MEM_SPACE_ACCOUNT_ID, data: memSyncUpdateValue, store });
  }
}
